/* tslint:disable */

// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum NextRecurringTipStateEnum {
  DONE = 'DONE',
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  READY = 'READY',
  REQUIRE_LOGIN = 'REQUIRE_LOGIN',
}

//==============================================================
// END Enums and Input Objects
//==============================================================
